module.exports = __webpack_public_path__ + "static/assets/a076c47938d4366efb08650456185831.png";